import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumbs = ({data}) => (
  <div className="margin-sm padding-md">
    {
      data &&
      data.map((branch, idx) =>
        <span key={idx}>
          <span className="breadcrumbs-separator">&gt;</span>

          <Link to={branch.path}>
            {branch.name}
          </Link>
        </span>
      )
    }
  </div>
);

export default Breadcrumbs;
